import {
  getAccessTokenFromCookie,
  getEidFromIdTokenInCookie,
  getIdTokenFromCookie,
  getSessionCookieData,
} from "../util/authentication";
import {
  ALL,
  STATION,
  SYSTEM_API_COMMON_CONFIG,
  SYSTEM_API_ERROR_LOG,
  SYSTEM_API_S3_PRESIGNED_URL_RETRIEVER,
} from "../util/constants";

export const sendClientErrorToServer = async (payload) => {
  const apiEndpoint = process.env.REACT_APP_SYSTEM_SERVICE_API + SYSTEM_API_ERROR_LOG;
  try {
    const response = await fetch(apiEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
        "SWA-STARS-IDToken": JSON.stringify(getSessionCookieData()),
        "SWA-STARS-EID": getEidFromIdTokenInCookie(),
      },
      body: JSON.stringify(payload),
    });
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getPresignedUrl = async (clientMethod, bucketName, objectId, contentType = "application/json") => {
  const apiEndpoint =
    process.env.REACT_APP_SYSTEM_SERVICE_API +
    SYSTEM_API_S3_PRESIGNED_URL_RETRIEVER +
    "/" +
    clientMethod +
    "/" +
    bucketName +
    "/" +
    objectId;
  try {
    const response = await fetch(apiEndpoint, {
      method: "GET",
      headers: {
        "Content-Type": encodeURIComponent(contentType),
        authorization: "Bearer " + getAccessTokenFromCookie(),
        "SWA-STARS-IDToken": getIdTokenFromCookie(),
        "SWA-STARS-EID": getEidFromIdTokenInCookie(),
      },
    });
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getFileFromS3 = async (presignedUrl) => {
  try {
    const response = await fetch(presignedUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const uploadFileToS3 = async (presignedUrl, file) => {
  try {
    const response = await fetch(presignedUrl, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-Amz-Meta-Swa-Stars-Idtoken": getIdTokenFromCookie(),
      },
      body: JSON.stringify(file),
    });
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const uploadCSVFileToS3 = async (presignedUrl, file) => {
  try {
    const response = await fetch(presignedUrl, {
      method: "PUT",
      headers: {
        "Content-Type": "text/csv",
        "X-Amz-Meta-Swa-Stars-Idtoken": getIdTokenFromCookie(),
      },
      body: file,
    });
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getSystemHealthEast = async () => {
  const apiEndpoint = process.env.REACT_APP_HEATH_CHECK_EAST;
  try {
    const response = await fetch(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getSystemHealthWest = async () => {
  const apiEndpoint = process.env.REACT_APP_HEATH_CHECK_WEST;
  try {
    const response = await fetch(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getServiceVersionsEast = async () => {
  const apiEndpoint = process.env.REACT_APP_SERVICE_VERSION_API_EAST;
  try {
    const response = await fetch(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
    });
    if (response.status === 200) {
      return response.json();
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getServiceVersionsWest = async () => {
  const apiEndpoint = process.env.REACT_APP_SERVICE_VERSION_API_WEST;
  try {
    const response = await fetch(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
    });
    if (response.status === 200) {
      return response.json();
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getStationList = async () => {
  const apiEndpoint = process.env.REACT_APP_SYSTEM_SERVICE_API + SYSTEM_API_COMMON_CONFIG + "/" + STATION + "/" + ALL;
  try {
    const response = await fetch(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};
